/*
 * @Desc: 角色管理 接口
 * @Author: may.li
 * @Date: 2023-05-21 10:24:59
 * @LastEditors: lc
 * @LastEditTime: 2023-06-06 11:57:48
 */
import request from "@/utils/request";
const index = {
  // 列表
  list (query) {
    return request({
      url: "/role/list",
      method: "get",
      params: query
    });
  },
  // 新增
  create (data) {
    return request({
      url: "/role/create",
      method: "post",
      data
    });
  },
  // 编辑
  edit (data) {
    return request({
      url: "/role/edit",
      method: "post",
      data
    });
  },
  // 详情
  detail (query) {
    return request({
      url: "/role/detail",
      method: "get",
      params: query
    });
  },
  // 修改状态
  status (data) {
    return request({
      url: "/role/status",
      method: "post",
      data
    });
  },
  // 删除
  remove (data) {
    return request({
      url: "/role/remove",
      method: "post",
      data
    });
  },
  // 下拉选
  select (query) {
    return request({
      url: "/role/select",
      method: "get",
      params: query
    });
  },
  // 获取角色的权限
  menuTree (query) {
    return request({
      url: "/menu/tree",
      method: "get",
      params: query
    });
  },
  // 修改角色的权限
  rolePriv (data) {
    return request({
      url: "/role/priv",
      method: "post",
      data
    });
  },
};
export default index;